export default "__VITE_ASSET__k96tBvd5__"